<template>
  <div class="show" v-if="showInfo">
    
    <div class="boxi">
      <div class="logo">
          <img :src="`${IP_TEST}/uploads/${logopic}`" alt="" @click="$router.push('/')">
        </div>
      <div class="content">
        <div class="headerinfo">
          <h2>
            课题信息查询结果
          </h2>
          <a class="back" href="/inquery?inqtype=kt"><img src="/static/img/chaxunicon.png" alt="">
            继续查询</a>
        </div>
        <div class="detailInfo">
          <table>
            <tr>
              <td colspan="4" class="ttitle"><img src="/static/img/zuo.png" alt="">  {{showInfo.certtypename}}<img src="/static/img/you.png" alt=""></td>
            </tr>
            <tr v-show="showInfo.name">
              <td><span class="titlep">课题名称：</span> </td>
              <td colspan="3">{{ showInfo.name }}</td>
            </tr>
            <tr v-show="showInfo.cardtype">
              <td><span class="titlep">课题类别：</span></td>
              <td colspan="3">{{ showInfo.cardtype }}</td>
            </tr>
            <tr v-show="showInfo.code">
              <td><span class="titlep">课题编码：</span></td>
              <td colspan="3">{{ showInfo.code }}</td>
            </tr>
           
            <tr v-show="showInfo.education">
              <td><span class="titlep">课题主持人：</span></td>
              <td colspan="3">{{ showInfo.education }}</td>
            </tr>
            <tr v-show="showInfo.certname">
              <td><span class="titlep">课题执行人：</span></td>
              <td colspan="3">{{ showInfo.certname}}</td>
            </tr>
            <tr v-show="showInfo.danwei">
              <td><span class="titlep">课题执行人所在单位：</span></td>
              <td colspan="3">{{ showInfo.danwei}}</td>
            </tr>
            <tr v-show="showInfo.majorfield">
              <td><span class="titlep">评审机构意见：</span></td>
              <td colspan="3">{{ showInfo.majorfield}}</td>
            </tr>
            <tr v-show="showInfo.regauth">
              <td><span class="titlep">评审机构：</span></td>
              <td colspan="3">{{ showInfo.regauth}}</td>
            </tr>
            <tr v-if="showInfo.picsrc">
              <td><span class="titlep">证书样本：</span></td>
              <td colspan="3" style="padding-top:10px">
                <el-image
                    style="width: 200px; height: 150px"
                    :src="`/uploads/xlsfile/usepic/${showInfo.picsrc}`"
                    :preview-src-list="[`/uploads/xlsfile/usepic/${showInfo.picsrc}`]"
                    :fit="fit"></el-image>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
/**
 * 企业证书查询系统模版
 */
import { IP_TEST } from '@/config';
const rate = window.outerWidth / 1400
export default {
  metaInfo: {
    title: '课题信息查询结果',
    meta: [
      {
        name: 'viewport', content:
          `width=device-width, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`
      }
    ]
  },
  name: "ShowQy",
  data() {
    return {
      IP_TEST,
      arrSprtQys:[]
    }
  },
  computed:{
    logopic() {
      return this.$store.getters.logopic;
    }
  },
  props: {
    showInfo: Object
  },
  mounted() {
    if(this.showInfo.nianjian)
    {
      let arrtmpsprts=this.showInfo.nianjian.split("##");
     
      for(let i = 0; i < arrtmpsprts.length;i++) {
        this.arrSprtQys[i]={
          title:arrtmpsprts[i].split("||")[0],
          date:arrtmpsprts[i].split("||")[1],
        }
      }
      this.$forceUpdate();
    }
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    formatExcelData(value) {
      let dataStr = this.formatExcel(value);
      if (isNaN(dataStr) && !isNaN(Date.parse(dataStr))) {
          value = new Date(dataStr);
          if (dataStr.indexOf("/") == -1 && dataStr.indexOf("-") == -1)
              value.setDate(value.getDate() + 1);
          value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
          -2
          )}月${("00" + value.getDate()).slice(-2)}日`;
          return value;
      } else {
          if (dataStr.indexOf("年") > -1) {
              var ttDate = dataStr.match(/\d{4}.\d{1,2}.\d{1,2}/gm).toString();
              ttDate = ttDate.replace(/[^0-9]/gm, "-");
              value = new Date(ttDate);
              value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
              return value;
          } else {
              if (!isNaN(dataStr)) {
                  var data = new Date(1900, 0, dataStr);
                  value = data;
                  value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
                  return value;
              } else {
                  return dataStr;
              }
          }
      }
    },
    formatExcel(value) {
        if (!value) {
            return "";
        } else {
            if (typeof value == "string") {
                return value.trim();
            } else {
                return value.toString().trim();
            }
        }
    }
  }
};
</script>
<style scoped>
 .show{
  position: relative;
  width: 100%;
  min-height:100%;
  background-color: #0157C6;
    background-image: url(/static/img/qybg.png);
    background-size: contain;
    background-repeat: no-repeat;
    background-position-y: bottom;
    padding-bottom: 100px;
}
.show .boxi{
  width: 1200px;
  margin: auto;
  position: relative;
  top:47px;
}
.show .boxi .logo{
  text-align: center;
}
.content{
  background: linear-gradient(0deg, #4686D9, #0157C6);
  border: 4px solid;
  border-image: linear-gradient(0deg, #1F74E2, #9EC8FF, #1F74E2, #9EC8FF) 4 4;
  box-shadow: 0px 0px 16px 0px #2E52C0;
  margin-top:65px;
  background-color: RGBA(20, 101, 204, 0.8);
background-image: url(/static/img/xian.png);
}
.content .headerinfo{
  
}
.content .headerinfo h2{
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 90px;
  width: 400px;
  margin-left: 41px;
}
.detailInfo{
  width: 1166px;
  padding: 12px 17px 28px 17px;

  border-radius: 5px;
}
.detailInfo .ttitle{
  text-align: center;
  font-size: 26px !important;
font-family: PingFang SC;
font-weight: bold;
letter-spacing: 2px;
height: 57px;
}
.detailInfo .ttitle img{
    position: relative;
    top:7px;
    margin: 0 10px;
  }
.detailInfo td{
  border:1px solid  #6497DA;;
  /* padding:5px 15px; */
  min-height: 54px;
  height: 54px;
  padding-left: 32px;
  font-size: 21px;
  line-height: 33px;
  
}
.detailInfo tr td:first-child{
  font-size: 18px;
  color: #FFFFFF;
  font-weight: bold;
  width: 190px;
  padding-left: 22px;
}
.detailInfo tr td{
  font-size: 18px;
  color: #FFFFFF;
  width: 1000px;
}
.headerinfo .back{
  color: #fff;
    float: right;
    margin-top: -63px;
    margin-right: 20px;
    font-size: 18px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 47px;
    width: 167px;
    height: 47px;
    background: #3D8CF0;
    border-radius: 5px;
    text-align: center;
}
.headerinfo .back img{
  position: relative;
  top:10px;
}
.titlep{
  display: inline-block;
    width: 180px;
    text-align: justify;
    text-justify:distribute-all-lines;
    text-align-last: justify;
}
</style>